import { RETRIEVE_COMMUNES } from "./types";

export const retrieveCommunes = (communes) => {
    return {
        type: RETRIEVE_COMMUNES,
        payload: communes,
    };
};